module.exports = __webpack_public_path__ + "static/img/5.1ef5363.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-educacion/5.png
// module id = XLAJ
// module chunks = 0